import { render, staticRenderFns } from "./proComOne.vue?vue&type=template&id=63be7649&scoped=true&"
import script from "./proComOne.vue?vue&type=script&lang=js&"
export * from "./proComOne.vue?vue&type=script&lang=js&"
import style0 from "./proComOne.vue?vue&type=style&index=0&id=63be7649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be7649",
  null
  
)

export default component.exports